import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment.prod';
import { DefaultLayoutAlignDirective } from '../../../../flex-layout/custom-layout-align';
import { DefaultFlexDirective } from '../../../../flex-layout/flex';
import { CalsoftService } from '../../../../services/calsoft.service';
import { ConfigServiceService } from '../../../../services/config-service.service';
import { LazyLoadImageModule } from 'ng-lazyload-image';

@Component({
  selector: 'calsoft-logo',
  imports: [DefaultFlexDirective, DefaultLayoutAlignDirective, LazyLoadImageModule],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss'
})
export class LogoComponent implements OnInit {
  @Input() type: string |any;
  @Input() component: string="dark";
  public serverPath = environment.commonImageApi + "logo/";
  @Input() sitename: string  |any;
  data :any;
  layout: any;
  defaultImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  websiteLogoSize: any;
  constructor( private calsoftService: CalsoftService, private configService: ConfigServiceService,
    private route:Router
    ) { }
  ngOnInit() {

    

  }

  closeMenu(){

    if(this.component=="menu"){
      this.calsoftService.sidenavOpen = false;
    }else{

      if(this.route.url!='/home'){
        this.route.navigate(['/']);
      }

    }

  }
  getConfigData() {
    this.configService.getConfigData()
      .subscribe(
        data => {
          this.websiteLogoSize=data['websiteLogoSize'];
         
        }, error => {

        }
      );
  }

}
